import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const styles_select = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    container: (provided) => ({ ...provided }),
    control: (provided) => ({ ...provided, paddingTop: '5px', paddingBottom: '5px' }),
    valueContainer: (provided) => ({ ...provided, overflow: 'visible', marginTop: '10px' }),
    placeholder: (provided, state) => ({
        ...provided,
        position: 'absolute',
        top: state.hasValue || state.selectProps.inputValue ? -15 : '0%',
        transition: 'top 0.1s, font-size 0.1s',
        fontSize: (state.hasValue || state.selectProps.inputValue) && 13
    })
};

const statusOpciones = [
    { value: false, label: 'Pendiente' },
    { value: true,  label: 'Pagado' }
];

const adeudadoOpciones = [
    { value: 0, label: 'Daniel' },
    { value: 1, label: 'Socio' }
];

const remobolsadoOpciones = [
    { value: 0, label: 'Aún no' },
    { value: 1, label: 'Pagado con dinero de venta' }
];

const FiltrosGasto = ({ show, handleCerrar, filtros, handleAplicar }) => {

    const sucursalesListado = useSelector(state => state.sucursales.listado);
    const proveedoresListado = useSelector(state => state.proveedores.listado);
    const metodosListado = useSelector(state => state.metodos.listado);
    const eventosListado = useSelector(state => state.eventos.listado);

    const [sucursalData, setSucursalData] = useState(null);
    const [proveedorData, setProveedorData] = useState(null);
    const [metodoData, setMetodoData] = useState(null);
    const [eventoData, setEventoData] = useState(null);
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);
    const [statusData, setStatusData] = useState(null);
    const [adeudadoData, setAdeudadoData] = useState(null);
    const [remobolsadoData, setRemobolsadoData] = useState(null);

    useEffect(() => {
        if (show) {
            setFechaInicio(filtros.fecha_inicio ? new Date(filtros.fecha_inicio) : null);
            setFechaFin(filtros.fecha_fin ? new Date(filtros.fecha_fin) : null);

            const sucOpc = sucursalesListado.map(s => ({ value: s._id, label: s.nombre }));
            setSucursalData(filtros.sucursal ? sucOpc.find(s => s.value === filtros.sucursal) ?? null : null);

            const provOpc = proveedoresListado.map(p => ({ value: p._id, label: p.nombre }));
            setProveedorData(filtros.proveedor ? provOpc.find(p => p.value === filtros.proveedor) ?? null : null);

            const metOpc = metodosListado.map(m => ({ value: m._id, label: m.nombre }));
            setMetodoData(filtros.metodo ? metOpc.find(m => m.value === filtros.metodo) ?? null : null);

            const evOpc = eventosListado.map(e => ({ value: e._id, label: e.nombre }));
            setEventoData(filtros.evento ? evOpc.find(e => e.value === filtros.evento) ?? null : null);

            setStatusData(filtros.status != null ? statusOpciones.find(o => o.value === filtros.status) ?? null : null);
            setAdeudadoData(filtros.adeudado != null ? adeudadoOpciones.find(o => o.value === filtros.adeudado) ?? null : null);
            setRemobolsadoData(filtros.remobolsado != null ? remobolsadoOpciones.find(o => o.value === filtros.remobolsado) ?? null : null);
        }
    }, [show]);

    const handleAplicarFiltros = () => {
        handleAplicar({
            sucursal: sucursalData ? sucursalData.value : null,
            proveedor: proveedorData ? proveedorData.value : null,
            metodo: metodoData ? metodoData.value : null,
            evento: eventoData ? eventoData.value : null,
            fecha_inicio: fechaInicio ? new Date(new Date(fechaInicio).setHours(0, 0, 0, 0)) : null,
            fecha_fin: fechaFin ? new Date(new Date(fechaFin).setHours(23, 59, 59, 999)) : null,
            status: statusData != null ? statusData.value : null,
            adeudado: adeudadoData != null ? adeudadoData.value : null,
            remobolsado: remobolsadoData != null ? remobolsadoData.value : null
        });
        handleCerrar();
    };

    const handleLimpiar = () => {
        setSucursalData(null);
        setProveedorData(null);
        setMetodoData(null);
        setEventoData(null);
        setFechaInicio(null);
        setFechaFin(null);
        setStatusData(null);
        setAdeudadoData(null);
        setRemobolsadoData(null);
        handleAplicar({ sucursal: null, proveedor: null, metodo: null, evento: null, fecha_inicio: null, fecha_fin: null, status: null, adeudado: null, remobolsado: null });
        handleCerrar();
    };

    const sucursalesOpciones = sucursalesListado.map(s => ({ value: s._id, label: s.nombre }));
    const proveedoresOpciones = proveedoresListado.map(p => ({ value: p._id, label: p.nombre }));
    const metodosOpciones = metodosListado.map(m => ({ value: m._id, label: m.nombre }));
    const eventosOpciones = eventosListado.map(e => ({ value: e._id, label: e.nombre }));


    return (
        <Modal show={show} size="lg" backdrop="static" centered onHide={handleCerrar}>
            <Modal.Header closeButton>
                <Modal.Title>Filtros</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row g-3">

                    <div className="col-6 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Sucursal"
                                options={sucursalesOpciones}
                                value={sucursalData}
                                onChange={option => setSucursalData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-6 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Proveedor"
                                options={proveedoresOpciones}
                                value={proveedorData}
                                onChange={option => setProveedorData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-6 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Método de pago"
                                options={metodosOpciones}
                                value={metodoData}
                                onChange={option => setMetodoData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-6 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Evento"
                                options={eventosOpciones}
                                value={eventoData}
                                onChange={option => setEventoData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="filtro_fecha_inicio"
                                    className="form-control text-center input-datepicker"
                                    selected={fechaInicio}
                                    onChange={date => setFechaInicio(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    isClearable
                                    autoComplete="off"
                                />
                                <label className="label-datepicker" htmlFor="filtro_fecha_inicio">Fecha inicio</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="filtro_fecha_fin"
                                    className="form-control text-center input-datepicker"
                                    selected={fechaFin}
                                    onChange={date => setFechaFin(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    isClearable
                                    autoComplete="off"
                                    minDate={fechaInicio}
                                />
                                <label className="label-datepicker" htmlFor="filtro_fecha_fin">Fecha fin</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-6 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Status"
                                options={statusOpciones}
                                value={statusData}
                                onChange={option => setStatusData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-4 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Adeudado a"
                                options={adeudadoOpciones}
                                value={adeudadoData}
                                onChange={option => setAdeudadoData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-8 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Reembolsado"
                                options={remobolsadoOpciones}
                                value={remobolsadoData}
                                onChange={option => setRemobolsadoData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-outline-secondary me-auto" onClick={handleLimpiar}>
                    <i className="fas fa-times me-1"></i> Limpiar
                </button>
                <button className="btn btn-secondary" onClick={handleCerrar}>
                    Cancelar
                </button>
                <button className="btn btn-primary" onClick={handleAplicarFiltros}>
                    <i className="fas fa-filter me-1"></i> Aplicar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default FiltrosGasto;
